import { render } from "./Modal.vue?vue&type=template&id=3cd4a01c&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=3cd4a01c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3cd4a01c"

export default script